module.exports = __webpack_public_path__ + "static/media/hide_icon.bc7f9949.svg";